// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__Pgqvw","Item":"Slider_Item__EtDs8","Image":"Slider_Image__jbnER","Title":"Slider_Title__ohsdt"};